module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8JqTz"))).then(() => parcelRequire('f4eak'));